var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBtc = function SvgBtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7931A",
    d: "M14.774 9.314A7.498 7.498 0 1 1 .224 5.686a7.498 7.498 0 0 1 14.55 3.628"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.805 6.432c.15-.998-.61-1.535-1.65-1.893l.338-1.352-.823-.205L8.342 4.3a34 34 0 0 0-.66-.156l.33-1.325-.822-.205-.337 1.352a27 27 0 0 1-.525-.124v-.004l-1.134-.283-.22.879s.611.14.598.148c.334.083.394.304.384.479L5.572 6.6a1 1 0 0 1 .086.028l-.087-.022-.539 2.158c-.04.101-.144.253-.377.195.008.012-.598-.149-.598-.149l-.409.942 1.071.267q.3.076.587.152l-.34 1.367.822.205.337-1.353q.336.091.656.17l-.336 1.347.823.205.34-1.365c1.404.266 2.459.159 2.903-1.11.358-1.023-.018-1.612-.756-1.997.538-.124.943-.477 1.05-1.208m-1.88 2.637c-.254 1.022-1.975.47-2.533.33l.452-1.811c.558.14 2.347.415 2.081 1.48m.255-2.652c-.232.93-1.665.457-2.13.342l.41-1.644c.465.116 1.961.332 1.72 1.302"
  })));
};
export default SvgBtc;